"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = void 0;
/**
 * Capitalizes a string
 * @param str the string to capitalize
 */
function capitalize(str) {
    if (str === "")
        return str;
    return str[0].toUpperCase() + str.substr(1).toLowerCase();
}
exports.capitalize = capitalize;
